import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AmplifyAuthenticatorModule } from '@aws-amplify/ui-angular';

/* new form imports */
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AppRoutingModule } from './app-routing.module';
import { MatAutocompleteModule } from '@angular/material/autocomplete';

import { AppComponent } from './app.component';
import { TokensComponent } from './tokens/tokens.component';
import { AutoCompleteBoxComponent } from './autoCompleteBox/autoCompleteBox.component';
import { SReceiptTableComponent } from 'src/app/doc2txt/receipt/table/sReceiptTable.component';
import { ExtrTblTableComponent } from 'src/app/doc2txt/extrTbl/table/extrTblTable.component';

import { SCanvasComponent } from 'src/app/canvas/canvas.component';
import { MatIconModule } from '@angular/material/icon';
import { MatRadioModule } from '@angular/material/radio';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { HttpClientModule } from '@angular/common/http';
import { ReceiptUploadPage } from 'src/app/doc2txt/receipt/upload/receiptUploadPage';
import { ExtrTblUploadPage } from 'src/app/doc2txt/extrTbl/upload/extrTblUploadPage';
import { APP_BASE_HREF } from '@angular/common';
import { AboutUsPageComponent } from './doc2txt/pages/about-us-page/about-us-page.component';
import { PricesComponent } from './doc2txt/pages/prices/prices.component';
import { StatsComponent } from './doc2txt/pages/stats/stats.component';
import { ContactUsComponent } from './doc2txt/pages/contact-us/contact-us.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MatTableModule } from '@angular/material/table';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { NgbAccordionModule } from '@ng-bootstrap/ng-bootstrap';
import { ClipboardModule } from '@angular/cdk/clipboard';

import { WeedexPageComponent } from './doc2txt/weedex-page/weedex-page.component';
import { WeedexTableComponent } from './doc2txt/weedex-page/weedex-table/weedex-table.component';
import { PassportPageComponent } from './doc2txt/passport-page/passport-page.component';
import { PassportTableComponent } from './doc2txt/passport-page/passport-table/passport-table.component';
import { TokenDetailsPageComponent } from './tokens/token-details-page/token-details-page.component';
import { BarcodePageComponent } from './doc2txt/barcode-page/barcode-page.component';
import { BarcodeTableComponent } from './doc2txt/barcode-page/barcode-table/barcode-table.component';
import { UserPageComponent } from './user/user-page/user-page.component';
import { AuthComponent } from './auth/auth.component';
import { FilterPipe } from './auth/country-code-select/filter.pipe';
import { SignInComponent } from './auth/sign-in/sign-in.component';
import { SignUpComponent } from './auth/sign-up/sign-up.component';
import { ConfirmCodeComponent } from './auth/confirm-code/confirm-code.component';
import { ProfileComponent } from './auth/profile/profile.component';
import { AvatarComponent } from './auth/profile/avatar/avatar.component';
import { SumitPaymentPageComponent } from './user/sumit-payment-page/sumit-payment-page.component';
import { UserPaymentSumComponent } from './user/user-payment-sum/user-payment-sum.component';
import { I18n } from 'aws-amplify';
import { translation } from './i18n/translation';
import { I18nPipe } from './i18n/I18nPipe';
import { ShowNeedTopUpComponent } from './token/show-need-top-up/show-need-top-up.component';
import { PaymentPipe } from './user/user-payment-sum/PaymentPipe';
import { ApiDocComponent } from './doc2txt/pages/api-doc/api-doc.component';
import { TagDataComponent } from './doc2txt/receipt/table/tag-data/tag-data.component';
import { OcrPlusComponent } from './doc2txt/ocrPlus/ocr-plus/ocr-plus.component';
import { OcrPlusUploadComponent } from './doc2txt/ocrPlus/ocr-plus-upload/ocr-plus-upload.component';
import { MatTabsModule } from '@angular/material/tabs';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { OcrPlusCanvasComponent } from './doc2txt/ocrPlus/ocr-plus-canvas/ocr-plus-canvas.component';
import { ChatGptContainerComponent } from './doc2txt/ocrPlus/chat-gpt-container/chat-gpt-container.component';
import { NewlinePipe } from './newline.pipe';

import { environment } from 'src/environments/environment';
import { ResumePageComponent } from './doc2txt/resume-page/resume-page.component';
import { ResumeTableComponent } from './doc2txt/resume-page/resume-table/resume-table.component';
import { TagListComponent } from './doc2txt/tag-list/tag-list.component';
import { SihachUploadPageComponent } from './doc2txt/sihach/upload/sihach-upload-page.component';
import { SihachTableComponent } from './doc2txt/sihach/sihach-table/sihach-table.component';
import { OcrCvTblTableComponent } from './doc2txt/ocrCvTbl/ocr-cv-tbl-table/ocr-cv-tbl-table.component';
import { OcrCvTblUploadComponent } from './doc2txt/ocrCvTbl/ocr-cv-tbl-upload/ocr-cv-tbl-upload.component';
import { OcrPlusTxtComponent } from './doc2txt/ocrPlus/ocr-plus-txt/ocr-plus-txt.component';
import { OcrPlusTxtPhraseComponent } from './doc2txt/ocrPlus/ocr-plus-txt-phrase/ocr-plus-txt-phrase.component';
import { OcrPlusTxtTblComponent } from './doc2txt/ocrPlus/ocr-plus-txt-tbl/ocr-plus-txt-tbl.component';
import { OcrPlusInvoiceComponent } from './doc2txt/ocr-plus-invoice/ocr-plus-invoice.component';
import { InvoiceTableComponent } from './doc2txt/ocr-plus-invoice/invoice-table/invoice-table.component';
import { ItemsTableComponent } from './doc2txt/ocr-plus-invoice/items-table/items-table.component';
import { InvoicePlusTableComponent } from './doc2txt/ocr-plus-invoice/invoice-plus-table/invoice-plus-table.component';
import { NgbCollapseModule } from '@ng-bootstrap/ng-bootstrap';

I18n.putVocabularies(translation);
// I18n.setLanguage('he');
I18n.setLanguage('en');

@NgModule({
  declarations: [
    I18nPipe,
    PaymentPipe,
    AppComponent,
    TokensComponent,
    SCanvasComponent,
    ReceiptUploadPage,
    ExtrTblUploadPage,
    SReceiptTableComponent,
    ExtrTblTableComponent,
    AboutUsPageComponent,
    PricesComponent,
    StatsComponent,
    ContactUsComponent,
    AutoCompleteBoxComponent,
    WeedexPageComponent,
    WeedexTableComponent,
    PassportPageComponent,
    PassportTableComponent,
    TokenDetailsPageComponent,
    BarcodePageComponent,
    BarcodeTableComponent,
    UserPageComponent,
    AuthComponent,
    FilterPipe,
    SignInComponent,
    SignUpComponent,
    ConfirmCodeComponent,
    ProfileComponent,
    AvatarComponent,
    SumitPaymentPageComponent,
    UserPaymentSumComponent,
    ShowNeedTopUpComponent,
    ApiDocComponent,
    TagDataComponent,
    OcrPlusComponent,
    OcrPlusUploadComponent,
    OcrPlusCanvasComponent,
    ChatGptContainerComponent,
    NewlinePipe,
    ResumePageComponent,
    ResumeTableComponent,
    TagListComponent,
    SihachUploadPageComponent,
    SihachTableComponent,
    OcrCvTblTableComponent,
    OcrCvTblUploadComponent,
    OcrPlusTxtComponent,
    OcrPlusTxtPhraseComponent,
    OcrPlusTxtTblComponent,
    OcrPlusInvoiceComponent,
    InvoiceTableComponent,
    ItemsTableComponent,
    InvoicePlusTableComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    AmplifyAuthenticatorModule,
    /* configuring form modules */
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    NgbModule,
    MatTableModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatMenuModule,
    MatToolbarModule,
    NgbAccordionModule,
    MatRadioModule,
    MatTabsModule,
    ClipboardModule,
    BrowserAnimationsModule,
    NgbCollapseModule,
    // SocketIoModule.forRoot(config)
  ],
  providers: [{ provide: APP_BASE_HREF, useValue: '/' }],
  bootstrap: [AppComponent],
})
export class AppModule {}
